<template>
  <div>
    <!-- 标题 -->
    <div class="instance-title">
      <Breadcrumb>
        <BreadcrumbItem>{{ this.$route.query.accountType }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.accountName }}</BreadcrumbItem>
        <BreadcrumbItem>{{ this.$route.query.region }}</BreadcrumbItem>
        <BreadcrumbItem to="/monitor/autoscalingMonitor">{{
          $t("alarms.autoscaling.autoscaling")
        }}</BreadcrumbItem>
        <BreadcrumbItem>
          <a @click="ipAddress">{{ $t("alarms.common.monitoringSummary") }}</a>
        </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!-- 查询框 -->
    <div class="instance-top">
      <Row :gutter="16">
        <Col span="6" v-show="isAWS">
          <Select v-model="timeType" @on-change="changeTimeType(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
        <Col span="6" v-if="isALY">
          <Select v-model="timeType" @on-change="changeTimeTypeALY(timeType)">
            <Option v-for="item in timeList" :value="item.id" :key="item.id">{{
              item.name
            }}</Option>
          </Select>
        </Col>
      </Row>
    </div>
    <!-- 折线图 -->
    <Row :gutter="16">
      <Col
        span="6"
        v-for="(item, index) in this.$route.query.accountType == 'AWS'
          ? awsList
          : this.$route.query.accountType == 'Aliyun'
          ? alyList
          : azureList"
        :key="index"
      >
        <Card :padding="8">
          <p slot="title">{{ item.title }}</p>
          <a href="#" slot="extra" @click.prevent="changeFull(item)">
            <Icon type="ios-expand" size="18" />
          </a>
          <div
            :id="item.id"
            :ref="item.id"
            style="width: 100%; height: 240px"
          ></div>
        </Card>
      </Col>
    </Row>
    <!-- 放大弹出框 -->
    <Modal
      v-model="isShowModal"
      :mask-closable="false"
      :closable="false"
      width="65%"
    >
      <Row>
        <Col span="24">
          <h3>{{ lineTitle }}</h3>
          <div
            id="chart-part"
            ref="fullChart"
            style="width: 100%; height: 420px"
          ></div>
        </Col>
      </Row>
      <div slot="footer">
        <div>
          <Button @click="cancel">{{ $t("alarms.common.close") }}</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil";
export default {
  name: "InatanceAutoscaling",
  data() {
    return {
      // 放大功能
      lineTitle: "",
      isShowModal: false,
      // AWS折线图
      awsList: [],
      // 阿里云折线图
      alyList: [
        {
          id: "maxInstanceCount",
          title: this.$t("alarms.autoscaling.line.MaxInstanceCount"),
        },
        {
          id: "minInstanceCount",
          title: this.$t("alarms.autoscaling.line.MinInstanceCount"),
        },
        {
          id: "pendingInstanceCount",
          title: this.$t("alarms.autoscaling.line.PendingInstanceCount"),
        },
        {
          id: "removingInstanceCount",
          title: this.$t("alarms.autoscaling.line.RemovingInstanceCount"),
        },
        {
          id: "runningInstanceCount",
          title: this.$t("alarms.autoscaling.line.RunningInstanceCount"),
        },
        {
          id: "totalInstanceCount",
          title: this.$t("alarms.autoscaling.line.TotalInstanceCount"),
        },
      ],
      // azure折线图
      azureList: [],
      isAWS: false,
      isALY: false,
      timeType: 0,
      timeList: [],
      id: "",
      accountId: "",
      name: "",
      period: "",
      accountType: "",
      accountName: "",
      region: "",
      monitorModule: "",
      natGatewayId: "",
      instanceId: "",
      // echarts实例
      maxInstanceCountOptions: {},
      minInstanceCountOptions: {},
      pendingInstanceCountOptions: {},
      removingInstanceCountOptions: {},
      runningInstanceCountOptions: {},
      totalInstanceCountOptions: {},
      chartMaxInstanceCount: "",
      chartMinInstanceCount: "",
      chartPendingInstanceCount: "",
      chartRemovingInstanceCount: "",
      chartRunningInstanceCount: "",
      chartTotalInstanceCount: "",
      //Aliyun数组
      maxInstanceCount: [],
      minInstanceCount: [],
      pendingInstanceCount: [],
      removingInstanceCount: [],
      runningInstanceCount: [],
      totalInstanceCount: [],
      xaxisData: [],
    };
  },
  mounted: function () {
    if (this.$route.query.accountType == "AWS") {
      this.isAWS = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {});
    } else if (this.$route.query.accountType == "Aliyun") {
      this.isALY = true;
      this.queryTimeHorizon();
      // 自适应不同屏幕尺寸
      const self = this;
      window.addEventListener("resize", function () {
        self.chartMaxInstanceCount.resize();
        self.chartMinInstanceCount.resize();
        self.chartPendingInstanceCount.resize();
        self.chartRemovingInstanceCount.resize();
        self.chartRunningInstanceCount.resize();
        self.chartTotalInstanceCount.resize();
      });
    }
  },
  created() {
    if (this.$route.query.accountType == "AWS") {
      this.isAWS = true;
      this.checkMonitorModuleIndex();
    } else if (this.$route.query.accountType == "Azure") {
      this.isAzure = true;
      this.checkAzureCloudVMDiskStatistics();
    } else if (this.$route.query.accountType == "Aliyun") {
      this.isALY = true;
      this.checkALIESSIndex();
    }
  },
  methods: {
    /******************放大********************************/
    changeFull: function (item) {
      this.isShowModal = true;
      this.lineTitle = item.title;
      this.$nextTick(() => {
        const chartFul = this.$refs.fullChart;
        if (chartFul) {
          const fullChart = this.$echarts.init(
            document.getElementById("chart-part")
          );
          fullChart.clear();
          if (item.id == "maxInstanceCount") {
            var optionFll = this.maxInstanceCountOption;
          } else if (item.id == "minInstanceCount") {
            var optionFll = this.minInstanceCountOption;
          } else if (item.id == "pendingInstanceCount") {
            var optionFll = this.pendingInstanceCountOption;
          } else if (item.id == "removingInstanceCount") {
            var optionFll = this.removingInstanceCountOption;
          } else if (item.id == "runningInstanceCount") {
            var optionFll = this.runningInstanceCountOption;
          } else if (item.id == "totalInstanceCount") {
            var optionFll = this.totalInstanceCountOption;
          }

          fullChart.setOption(optionFll);
          window.addEventListener("resize", function () {
            fullChart.resize();
          });
        }
      });
    },
    // 模态框取消事件
    cancel() {
      this.isShowModal = false;
    },
    /******************查询********************************/
    // 查询时间范围
    queryTimeHorizon: function () {
      this.$api.cloudWatch
        .queryTimeHorizon("userName", getCookie(global.cookieName))
        .then((res) => {
          this.timeList = res.data;
        });
    },
    // Aliyun折线图
    checkALIESSIndex: function () {
      this.$api.cloudWatch
        .checkALIESSIndex({
          keyId: this.$route.query.id,
          timeHorizon: this.timeType,
        })
        .then((res) => {
          this.xaxisData = res.data.xaxisData;
          this.maxInstanceCount = res.data.maxInstanceCount;
          this.minInstanceCount = res.data.minInstanceCount;
          this.pendingInstanceCount = res.data.pendingInstanceCount;
          this.removingInstanceCount = res.data.removingInstanceCount;
          this.runningInstanceCount = res.data.runningInstanceCount;
          this.totalInstanceCount = res.data.totalInstanceCount;
          this.allAws();
        });
    },
    changeTimeType: function () {
      this.checkAWSEipStatistics();
    },
    changeTimeTypeALY: function () {
      this.checkALIESSIndex();
    },
    /******************所有折线图********************************/
    allAws: function () {
      this.maxInstanceCountLine();
      this.minInstanceCountLine();
      this.pendingInstanceCountLine();
      this.removingInstanceCountLine();
      this.runningInstanceCountLine();
      this.totalInstanceCountLine();
    },
    /*************Aliyun折线图*****************************/
    //最大实例数
    maxInstanceCountLine: function () {
      this.chartMaxInstanceCount = this.$echarts.init(
        document.getElementById("maxInstanceCount")
      );
      this.maxInstanceCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.autoscaling.line.MaxInstanceCount")],
        },
        series: [
          {
            name: this.$t("alarms.autoscaling.line.MaxInstanceCount"),
            type: "line",
            data: this.maxInstanceCount,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartMaxInstanceCount.setOption(this.maxInstanceCountOption);
    },
    //最小实例数
    minInstanceCountLine: function () {
      this.chartMinInstanceCount = this.$echarts.init(
        document.getElementById("minInstanceCount")
      );
      this.minInstanceCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.autoscaling.line.MinInstanceCount")],
        },
        series: [
          {
            name: this.$t("alarms.autoscaling.line.MinInstanceCount"),
            type: "line",
            data: this.minInstanceCount,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartMinInstanceCount.setOption(this.minInstanceCountOption);
    },
    //正在加入实例数
    pendingInstanceCountLine: function () {
      this.chartPendingInstanceCount = this.$echarts.init(
        document.getElementById("pendingInstanceCount")
      );
      this.pendingInstanceCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.autoscaling.line.PendingInstanceCount")],
        },
        series: [
          {
            name: this.$t("alarms.autoscaling.line.PendingInstanceCount"),
            type: "line",
            data: this.pendingInstanceCount,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartPendingInstanceCount.setOption(this.pendingInstanceCountOption);
    },
    //正在移除实例数
    removingInstanceCountLine: function () {
      this.chartRemovingInstanceCount = this.$echarts.init(
        document.getElementById("removingInstanceCount")
      );
      this.removingInstanceCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.autoscaling.line.RemovingInstanceCount")],
        },
        series: [
          {
            name: this.$t("alarms.autoscaling.line.RemovingInstanceCount"),
            type: "line",
            data: this.removingInstanceCount,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartRemovingInstanceCount.setOption(
        this.removingInstanceCountOption
      );
    },
    //运行实例数
    runningInstanceCountLine: function () {
      this.chartRunningInstanceCount = this.$echarts.init(
        document.getElementById("runningInstanceCount")
      );
      this.runningInstanceCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.autoscaling.line.RunningInstanceCount")],
        },
        series: [
          {
            name: this.$t("alarms.autoscaling.line.RunningInstanceCount"),
            type: "line",
            data: this.runningInstanceCount,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartRunningInstanceCount.setOption(this.runningInstanceCountOption);
    },
    //最大实例数
    totalInstanceCountLine: function () {
      this.chartTotalInstanceCount = this.$echarts.init(
        document.getElementById("totalInstanceCount")
      );
      this.totalInstanceCountOption = {
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          x: "right",
          y: "10px",
          data: [this.$t("alarms.autoscaling.line.TotalInstanceCount")],
        },
        series: [
          {
            name: this.$t("alarms.autoscaling.line.TotalInstanceCount"),
            type: "line",
            data: this.totalInstanceCount,
            itemStyle: {
              normal: {
                color: "#123421",
                lineStyle: {
                  color: "#123421",
                },
              },
            },
          },
        ],
        grid: {
          left: "3%",
          bottom: "3%",
          top: "20%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xaxisData.map(function (str) {
              return str.replace(" ", "\n");
            }),
          },
        ],
        yAxis: [
          {
            splitNumber: 4,
            type: "value",
          },
        ],
      };

      this.chartTotalInstanceCount.setOption(this.totalInstanceCountOption);
    },
    /********************************/
    // 点击返回详情页
    ipAddress: function () {
      this.id = this.$route.query.id;
      this.accountId = this.$route.query.accountId;
      this.region = this.$route.query.region;
      this.accountType = this.$route.query.accountType;
      this.accountName = this.$route.query.accountName;
      this.name = this.$route.query.name;
      this.instanceId = this.$route.query.instanceId;
      this.$router.push({
        path: "/monitor/autoscalingDetail/",
        query: {
          id: this.id,
          accountId: this.accountId,
          instanceId: this.instanceId,
          region: this.region,
          accountType: this.accountType,
          accountName: this.accountName,
          name: this.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.instance-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.ivu-col-span-8 {
  margin-bottom: 20px;
}
.instance-top {
  width: 100%;
  height: 53px;
}
.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/autoscaling/instance_dashboard/InstanceAutoscaling.vue